/* eslint-disable no-use-before-define */
const contentWrapper = document.querySelector('[data-content-wrapper]');
let interval = null;

if (localStorage.getItem('twFontsCached')) {
  contentWrapper.classList.remove('font-loading');
} else {
  localStorage.setItem('twFontsCached', 'true');
  interval = setInterval(fontLoadListener, 500);
}

function fontLoadedSuccess() {
  if (interval) {
    clearInterval(interval);
  }
  contentWrapper.classList.remove('font-loading');
}

function fontLoadListener() {
  let hasLoaded = false;

  try {
    hasLoaded = document.fonts.check('1rem "FuturaPT"');
  } catch (error) {
    console.info('CSS font loading API error', error);
    fontLoadedSuccess();
    return;
  }

  if (hasLoaded) {
    fontLoadedSuccess();
  }
}

contentWrapper.style.visibility = 'visible';
